import { createWebPushDriver } from '@agentic-flow-studio/shared/lib/push-driver';

/**
 * Module-level singleton, not a per-render factory: `usePushSetup` keys effects
 * on the driver identity, so a fresh object each render would re-read
 * diagnostics forever.
 *
 * The platform string is what lets the backend build a Clinic deep link for
 * tokens registered here — see `push_devices.platform`.
 */
export const pushDriver = createWebPushDriver('clinic-portal');
